<script setup lang="ts">

const props = defineProps<{
  managerInfo: any;
}>()

const managerInfo = computed(() => props.managerInfo);

</script>

<template>
    <div class="content">
        <div class="wrapper" v-if="managerInfo">
          <template v-for="(manager, i) in managerInfo">
            <!-- <div class="title" v-if="manager.companyKind !== 'rtu'"> -->
            <div class="title" v-if="i === 0">
              시공업체 담당자 정보
            </div>
            <div class="title" v-else>
              RTU 담당자 정보
            </div>
            <div class="content-wrapper" :style="{paddingTop: '15px'}">
              <span class="first_letter">업체명</span>
              <span>{{ commonUtils.isAllStrDataEmpty(manager.companyName) }}</span>
            </div>
            <div class="content-wrapper">
              <span class="first_letter">담당자명</span>
              <span>{{ commonUtils.isAllStrDataEmpty(manager.name) }}</span>
            </div>
            <div class="content-wrapper">
              <span class="first_letter">전화번호</span>
              <span>{{ commonUtils.isAllStrDataEmpty(manager.phone) }}</span>
            </div>
            <div class="content-wrapper">
              <span class="first_letter">휴대전화번호</span>
              <span>{{ commonUtils.isAllStrDataEmpty(manager.mobile) }}</span>
            </div>
            <div class="content-wrapper">
              <span class="first_letter">이메일주소</span>
              <span>{{ commonUtils.isAllStrDataEmpty(manager.email) }}</span>
            </div>
          </template>
          
      </div>
      <div class="spec-no-data" v-else>
        담당자정보가 존재하지 않습니다.
      </div>
        <!-- <div class="title" :style="{borderTop: '1px solid #6b7271', paddingTop: '15px'}">
        </div> -->
 
    
    </div>
  </template>

<style lang="scss" scoped>
@import '@/assets/styles/design-toc/in-equip-card.scss';
</style>